import React, { useEffect, useState } from "react";
import { contentContainer, contentClass, visible } from './style.module.css'

const ModalStateLess = ({ show, content, hideModal, addZIndex=0 }) => {
	const [isVisible, setIsVisible] = useState(false);
	const [idBackDrop, setIdBackDrop] = useState(null)

	const toggleVisibility = () => {
		setIsVisible(!isVisible);
	};

	useEffect(() => {
		setIsVisible(show);
	}, [show]);

	useEffect(()=>{
		setIdBackDrop(`idbd_${new Date().getTime()}`)
	},[])

	return (
		<>
			{isVisible ? (
				<div
					// id="backdropstateless"
					id={idBackDrop}
					className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none bg-[#0005]"
					style={{
						zIndex: (9900 + addZIndex)
					}}
					onClick={(e) => {
						// if (e.target.id && e.target.id === 'backdropstateless') {
						if (e.target.id && e.target.id === idBackDrop) {
							hideModal();
							// setIsVisible(false);
						}
					}}
				>
					<div className="relative w-auto my-6 mx-auto max-w-[90vw]" style={{
						zIndex: (9901 + addZIndex)
					}}>
						{/*content*/}
						<div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
							{/*body*/}
							<div className="min-w-[300px] lg:min-w-[600px] max-w-[87vw] lg:max-w-[70vw] relative p-6 flex-auto max-h-[90vh] overflow-y-auto">
								{content}
							</div>
						</div>
					</div>
				</div>
			) : (
				<></>
			)}
		</>
	);
};

export default ModalStateLess;